var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiftFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#039"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.84,46.095h9.707V32.168H28.84ZM40.765,34.067l1.79-1.791,1.79,1.791m0,10.128-1.79,1.79-1.79-1.79m-6.228-9.706a.844.844,0,1,1-.844-.844.844.844,0,0,1,.844.844Zm.844,6.752v-4.22H32v4.22h.844v3.376h1.688V41.241Z",
    transform: "translate(-22.531 -25.131)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiftFilter);
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28'%3e%3ccircle cx='14' cy='14' r='14' fill='%23039'/%3e%3cpath d='M28.84,46.095h9.707V32.168H28.84ZM40.765,34.067l1.79-1.791,1.79,1.791m0,10.128-1.79,1.79-1.79-1.79m-6.228-9.706a.844.844,0,1,1-.844-.844.844.844,0,0,1,.844.844Zm.844,6.752v-4.22H32v4.22h.844v3.376h1.688V41.241Z' transform='translate(-22.531 -25.131)' fill='none' stroke='%23fff' stroke-width='1'/%3e%3c/svg%3e";
export { ForwardRef as ReactComponent };